// import React, { useEffect, useState } from "react";
// import { vendorApi } from "../../services/vendorApi";

// export default function PayoutHistoryPage() {
//   const token = localStorage.getItem("vendor_token") || "";

//   const [loading, setLoading] = useState(true);
//   const [err, setErr] = useState("");
//   const [rows, setRows] = useState([]);

//   const loadHistory = async () => {
//     setErr("");
//     setLoading(true);
//     try {
//       const res = await vendorApi.payoutHistory(token);
//       if (!res?.success) throw new Error(res?.message || "History fetch failed");
//       setRows(res.rows || []);
//     } catch (e) {
//       setErr(e.message || "Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadHistory();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return (
//     <div style={{ padding: 18 }}>
//       <h2 style={{ marginTop: 0 }}>Payout History</h2>

//       {err ? (
//         <div style={{ background: "#ffd7d7", padding: 10, borderRadius: 10, marginBottom: 12 }}>
//           {err}
//         </div>
//       ) : null}

//       {loading ? (
//         <div>Loading...</div>
//       ) : (
//         <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #eee", overflow: "hidden" }}>
//           <div style={{ display: "grid", gridTemplateColumns: "90px 140px 120px 1fr 180px", gap: 0, padding: 12, fontWeight: 700, background: "#f7f7f7" }}>
//             <div>ID</div>
//             <div>Amount</div>
//             <div>Status</div>
//             <div>Note</div>
//             <div>Date</div>
//           </div>

//           {rows.length === 0 ? (
//             <div style={{ padding: 12, opacity: 0.7 }}>No payout records</div>
//           ) : (
//             rows.map((r) => (
//               <div
//                 key={r.id}
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "90px 140px 120px 1fr 180px",
//                   padding: 12,
//                   borderTop: "1px solid #eee",
//                   alignItems: "center",
//                 }}
//               >
//                 <div>{r.id}</div>
//                 <div>₹ {Number(r.amount || 0).toFixed(2)}</div>
//                 <div>{r.status}</div>
//                 <div style={{ opacity: 0.8 }}>{r.note || "-"}</div>
//                 <div style={{ opacity: 0.8 }}>
//                   {r.created_at ? String(r.created_at).replace("T", " ").slice(0, 19) : "-"}
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

//new

import React, { useEffect, useState } from "react";
import { vendorApi } from "../../services/vendorApi";
import "./Wallet.css";

function money(n) {
  return (
    "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })
  );
}

function fmtDate(d) {
  if (!d) return "-";
  return String(d).replace("T", " ").slice(0, 19);
}

function statusConfig(s) {
  const x = String(s || "").toLowerCase();
  if (x === "accepted") return { cls: "pw-badge-green", label: "Accepted" };
  if (x === "rejected") return { cls: "pw-badge-red", label: "Rejected" };
  return { cls: "pw-badge-amber", label: "Pending" };
}

export default function PayoutHistoryPage() {
  const token = localStorage.getItem("vendor_token") || "";

  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [rows, setRows] = useState([]);

  const loadHistory = async () => {
    setErr("");
    setLoading(true);
    try {
      const res = await vendorApi.payoutHistory(token);
      if (!res?.success)
        throw new Error(res?.message || "History fetch failed");
      setRows(res.rows || []);
    } catch (e) {
      setErr(e.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const acceptedTotal = rows
    .filter((r) => String(r.status).toLowerCase() === "accepted")
    .reduce((a, r) => a + Number(r.amount || 0), 0);
  const pendingTotal = rows
    .filter((r) => String(r.status).toLowerCase() === "pending")
    .reduce((a, r) => a + Number(r.amount || 0), 0);

  return (
    <div className="pw-page">
      {/* Header */}
      <div className="pw-header">
        <div className="pw-header-left">
          <div className="pw-header-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
          </div>
          <div>
            <h1 className="pw-title">Payout History</h1>
            <p className="pw-subtitle">{rows.length} total requests</p>
          </div>
        </div>
        <button className="pw-refresh-btn" onClick={loadHistory}>
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          >
            <polyline points="23 4 23 10 17 10" />
            <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" />
          </svg>
          Refresh
        </button>
      </div>

      {/* Summary Stats */}
      <div className="pw-stats">
        <div className="pw-stat pw-stat-green">
          <div className="pw-stat-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <div className="pw-stat-body">
            <div className="pw-stat-label">Total Accepted</div>
            <div className="pw-stat-val">{money(acceptedTotal)}</div>
          </div>
        </div>
        <div className="pw-stat pw-stat-amber">
          <div className="pw-stat-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <div className="pw-stat-body">
            <div className="pw-stat-label">Total Pending</div>
            <div className="pw-stat-val">{money(pendingTotal)}</div>
          </div>
        </div>
        <div className="pw-stat pw-stat-blue">
          <div className="pw-stat-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
          </div>
          <div className="pw-stat-body">
            <div className="pw-stat-label">Total Requests</div>
            <div className="pw-stat-val">{rows.length}</div>
          </div>
        </div>
      </div>

      {/* Error */}
      {err && (
        <div className="pw-alert pw-alert-err">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            style={{ flexShrink: 0 }}
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          {err}
        </div>
      )}

      {/* Table Card */}
      <div className="pw-card">
        <div className="pw-card-head">
          <div className="pw-card-icon pw-card-icon-blue">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            >
              <line x1="8" y1="6" x2="21" y2="6" />
              <line x1="8" y1="12" x2="21" y2="12" />
              <line x1="8" y1="18" x2="21" y2="18" />
              <line x1="3" y1="6" x2="3.01" y2="6" />
            </svg>
          </div>
          <div>
            <div className="pw-card-title">All Payout Requests</div>
            <div className="pw-card-sub">
              Complete history of your payout requests
            </div>
          </div>
        </div>

        {loading ? (
          <div className="pw-state">
            <div className="pw-spinner pw-spinner-lg" />
            <p>Loading history…</p>
          </div>
        ) : rows.length === 0 ? (
          <div className="pw-state">
            <div className="pw-empty-icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              >
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            </div>
            <p className="pw-empty-title">No payout records</p>
            <p className="pw-empty-sub">
              Your payout requests will appear here
            </p>
          </div>
        ) : (
          <div className="pw-table-wrap">
            <table className="pw-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Note</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, idx) => {
                  const sc = statusConfig(r.status);
                  return (
                    <tr key={r.id ?? idx}>
                      <td className="pw-td-num">{idx + 1}</td>
                      <td className="pw-td-amount">{money(r.amount)}</td>
                      <td>
                        <span className={`pw-badge ${sc.cls}`}>
                          <span className="pw-badge-dot" />
                          {sc.label}
                        </span>
                      </td>
                      <td className="pw-td-note">{r.note || "—"}</td>
                      <td className="pw-td-date">{fmtDate(r.created_at)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
